'use strict';
var parent = require('../../actual/array/from');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/full/array/from.js
// module id = 359
// module chunks = 0